import axios, { type AxiosError, type AxiosRequestConfig } from 'axios'

/**
 * Make axios request with error handling
 */
export async function makeRequest<T>(
  url: string,
  options: AxiosRequestConfig = {},
): Promise<T> {
  try {
    const customHeaders = { 'X-Requested-With': 'XMLHttpRequest' }
    options.headers = { ...customHeaders, ...options.headers }

    const response = await axios.request({
      url,
      ...options,
    })

    return response?.data
  } catch (error: unknown) {
    const safeError = (error || new Error()) as AxiosError & {
      data?: unknown
      status?: number
    }
    const loggedOutErrorCodes = [401]
    const statusCode =
      safeError.response?.status ??
      (safeError.response as { statusCode?: number } | undefined)?.statusCode
    const userIsLoggedOut = loggedOutErrorCodes.includes(statusCode ?? 0)

    if (userIsLoggedOut && safeError.response?.headers?.location) {
      window.location.href = safeError.response.headers.location as string
    }

    safeError.data = safeError.response
    safeError.status = statusCode

    throw safeError
  }
}
